/** @file Renames a slot (ASCII name, unique among slots); the current name writes nothing. */
import { defineCommand } from '../defineCommand';
import { defineRename } from '../_shared/defineRename';

const renameSlot = defineRename({ domain: 'slot', kind: 'slot', description: 'Rename a slot (ASCII name, unique among slots; use -L/-R suffixes for sides).' });

/** slot.rename: names are unique per kind (a slot may share a bone's name); the current name is a no-op (R2-13). */
export const command = defineCommand({
  ...renameSlot,
  apply(draft, input, ctx) {
    if (draft.slots[ctx.resolve('slot', input.target)]?.name === input.name) return;
    renameSlot.apply(draft, input, ctx);
  },
});
